module.exports = __webpack_public_path__ + "static/media/edit_icon.e1cf3ff5.svg";